<template>
  <div class="wrapper hefei-bg-f5">
    <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore">
      <div class="container-wrap-form history-illness-desp">
        <div class="form-bg history-item" @click="check(item)" v-for="(item, i) in list" :key="i">
          <div class="history-item-title arrow-right">
            <h2>{{ item.createTime | dateFormatFilter }}</h2>
          </div>
          <p>{{ item.symptomDesc }}</p>
        </div>
      </div>
    </mt-loadmore>
    <DefaultPage
      :text="defautlTxt"
      v-if="!list.length && !loading"
    />
  </div>
</template>
<script>
import DefaultPage from '../../components/common/DefaultPage'

export default {
  filters: {
    dateFormatFilter (value) {
      if (value) {
        return `${value.slice(0, 4)}/${value.slice(4, 6)}/${value.slice(6, 8)} ${value.slice(8, 10)}:${value.slice(10, 12)}:${value.slice(12, 14)}` || '-'
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      list: [],
      allLoaded: false,
      pageNo: 1,
      rows: 20,
      defautlTxt: "暂无记录",
      loading: false
    };
  },
  components: {
    DefaultPage
  },
  methods: {
    check(item) {
      const desc = {};
      desc.symptomDesc = item.symptomDesc;
      desc.imgUrl = item.imgUrl;
      sessionStorage.setItem("HISTORY-DESC-ITEM", JSON.stringify(desc))
      this.$router.go(-1);
    },
    getList() {
      this.loading = true;
      this.$http
        .getSymptomDescList(
          {},
          {
            pageNo: this.pageNo,
            rows: this.rows
          }
        )
        .then(res => {
          if (res && res.length > 0) {
            res.forEach(ele => {
              this.list.push(ele);
            });
            console.log(this.list)
            this.pageNo++;
          }
          if (res.length < this.rows) {
            this.allLoaded = true;
          } else {
            this.$refs.loadmore.onBottomLoaded();
          }
          this.loading = false;
        });
    },
    loadBottom() {
      this.getList();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/patientEnd/historyDescs.vue